import { Route, Routes } from 'react-router-dom';

import { paths } from 'data/routes';

import { Others } from './sections/Others';
import { Technologies } from './sections/Technologies';

export function InfoPage(): React.ReactElement {
  return (
    <Routes>
      <Route path={paths.others} element={<Others />} />

      <Route path={paths.technologies} element={<Technologies />} />
    </Routes>
  );
}
